module.exports = __webpack_public_path__ + "img/t1-17.b21ff834.png";